import React from "react";
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip } from "recharts";

const fmtInt = (n) =>
  new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 0 }).format(Number(n || 0));

function pct(a, b) {
  const A = Number(a || 0);
  const B = Number(b || 0);
  if (!B) return 0;
  return (A / B) * 100;
}

function CustomTooltip({ active, payload }) {
  if (!active || !payload?.length) return null;
  const p = payload[0]?.payload;
  return (
    <div className="rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 shadow-lg px-3 py-2">
      <div className="text-sm font-semibold text-slate-900 dark:text-slate-100">
        {p?.name}
      </div>
      <div className="mt-1 text-xs text-slate-600 dark:text-slate-300">
        {fmtInt(p?.value)} ({Number(p?.pct || 0).toFixed(1)}%)
      </div>
    </div>
  );
}

export function MembersDonut({ licencies = 0, inscrits = 0, loading = false }) {
  if (loading) {
    return <div className="h-[280px] rounded-xl bg-slate-100 dark:bg-slate-800 animate-pulse" />;
  }

  const lic = Number(licencies || 0);
  const ins = Number(inscrits || 0);
  const total = lic + ins;

  if (!total) {
    return (
      <div className="h-[280px] rounded-xl border border-slate-200 dark:border-slate-800 flex items-center justify-center text-slate-500">
        Aucune donnée
      </div>
    );
  }

  const data = [
    { name: "Licenciés", value: lic, pct: pct(lic, total) },
    { name: "Inscrits", value: ins, pct: pct(ins, total) },
  ];

  const COLORS = ["#5A8DEE", "#FF6A88"];

  return (
    <div className="h-[280px] relative">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Tooltip content={<CustomTooltip />} />
          <Pie
            data={data}
            dataKey="value"
            nameKey="name"
            innerRadius="62%"
            outerRadius="85%"
            paddingAngle={3}
            stroke="transparent"
          >
            {data.map((_, idx) => (
              <Cell key={idx} fill={COLORS[idx]} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>

      {/* Centre */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
        <div className="text-center">
          <div className="text-xs text-slate-500">Total</div>
          <div className="text-2xl font-semibold text-slate-900 dark:text-slate-100 tabular-nums">
            {fmtInt(total)}
          </div>
          <div className="mt-1 text-[11px] text-slate-500">
            Inscrits : <span className="font-semibold">{pct(ins, total).toFixed(1)}%</span>
          </div>
        </div>
      </div>

      {/* Légende minimaliste */}
      <div className="mt-2 flex justify-center gap-4 text-xs text-slate-600 dark:text-slate-300">
        <div className="flex items-center gap-2">
          <span className="h-2.5 w-2.5 rounded-full" style={{ background: COLORS[0] }} />
          Licenciés
        </div>
        <div className="flex items-center gap-2">
          <span className="h-2.5 w-2.5 rounded-full" style={{ background: COLORS[1] }} />
          Inscrits
        </div>
      </div>
    </div>
  );
}

export default MembersDonut;
